
// EmployeePinEntry.jsx
import React from 'react';
import PinInput from 'react-pin-input';
import '../otp-input.css';

const PinEntry = ({ handleOnCompletePin }) => {
	let pin;
	return (

		<div className="Pin home-container">
			<PinInput 
				length={4} 
				// initialValue=""
				focus
				// secret 
				onChange={(value, index) => {}} 
				type="numeric" 
				ref={p => (pin = p)}
				inputMode="number"
				style={{padding: '10px'}}  
				inputStyle={
					{ 
						borderColor: '#5e07a0', 
						borderRadius: '10%', 
						width: '43px', 
						maxwidth: '15%' 
					}
				}
				inputFocusStyle={{borderColor: 'blue'}}
				onComplete={(value) => 
					{
						handleOnCompletePin(value);
						pin.clear()
					}
				}
				autoSelect={true}
				regexCriteria={/[0-9]*/}
			/>
		</div>
	)
};

export default PinEntry;